// extracted by mini-css-extract-plugin
module.exports = {"container":"_1DUP_Z2WU8Xguwpm0orlt9"};